<template>
  <div class="this noselect">
    <!--        @click.passive.stop="$ebus.$emit('goto',{name:'Korb', params: {}, scrollTarget:''})"-->

    <!--        <div class="absBack" style="top: 137px;">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->


    <!--        <cat-slider-->
    <!--                @selectCat="gotoCat"></cat-slider>-->
    <!--        <div style="height: 70px"></div>-->


    <!--        <h1 class="text-center">Korb</h1>-->


    <!--        <div class="indented">-->
    <h2 class="text-center pointer" @click.passive="gotoCart">Warenkorb</h2>
    <div v-if="cartItems.length === 0" class="text-center">
      <div class="spacer-40"></div>
      <div class="">Der Korb ist leer</div>
    </div>

    <!--            <p>Ab einem Bestellwert von 30 Euro erhälst Du ein hochwertiges Öl-->
    <!--                in der kleinen Geschenk- oder Sprühflasche gratis dazu 🎁. Hier findest du Beispiele an-->
    <!--                <router-link :to="{ name: 'Geschenkverpackung' }">Geschenkverpackungen</router-link>-->
    <!--                .-->
    <!--            </p>-->

    <div class="pmRow" v-if="cartItems.length > 0">
      <table class="theader maxw">
        <tr>
          <td class="text-left" style="width: auto">
            Artikel
          </td>
          <!--                        <td style="width: 154px" class="text-center">-->
          <!--                            <div class="anzahl" style="width: 154px">Anzahl<span class="hidden-sm-and-up">/Preis</span>-->
          <!--                            </div>-->
          <!--                        </td>-->
          <!--                        <td style="width: 90px" class="text-center hidden-xs-only">Preis</td>-->
        </tr>
      </table>
    </div>

    <div class="itemRow pmRow" v-for="item in cartItems">

      <table class="maxw items " v-if="item.isCoupon" @click.passive="showCouponInfo(item)">
        <tr>
          <td class="b text-left">
            <div style="overflow-x: hidden; overflow-y: clip;">
              <div>
                <!--                                <div style="font-size: 1.3em;">-->
                {{ item.nameToDisplay }}
                <!--                                    <span v-if="item.description"> | {{item.description}}</span>-->
              </div>
              <div v-if="item.text" class="displayExtras">
                {{ item.text }}
              </div>
            </div>
          </td>
          <td class="c counterStuff">
            <v-row>
              <v-col>
                <div class="d-flex justify-end align-center maxh" style="opacity: 0">
                  <img class="minusImg pointer invertImg"
                       src="../assets/icons/item-minus.png">
                  <div>0</div>
                  <img class="plusImg pointer invertImg"
                       src="../assets/icons/item-plus.png">
                </div>
              </v-col>
              <!--                                <v-col>-->
              <!--                                    <div class="d-flex justify-end align-center maxh">-->
              <!--                                        <div v-if="item.type==='bundle'">{{item.amount | price}}</div>-->
              <!--                                        <div v-if="item.type==='amount'">-{{item.amount | price}}</div>-->
              <!--                                        <div v-if="item.type==='discount'">-{{item.discount}}%</div>-->
              <!--                                        <v-icon medium @click.native.passive="deleteCartItem(item)"-->
              <!--                                                class="ml-2 hidden-xs-only myWhite pointer">mdi-delete-forever-->
              <!--                                        </v-icon>-->
              <!--                                    </div>-->
              <!--                                </v-col>-->
            </v-row>
          </td>
        </tr>
      </table>
      <table class="maxw items" v-else>
        <tr>
          <td class="b text-left">
            <div style="overflow-x: hidden; overflow-y: clip" class="" @click="gotoItem(item)">
              <div>
                <!--                                <div style="font-size: 1.2em;">-->
                <span v-if="item.isOffer"><span
                  v-if="item.usecase ==='takeAway'">Abholer-Angebot</span><span
                  v-else>Angebot</span>: </span>
                <!--                                    Verfügbargeit-->
                <!--                                    <v-icon class="mr-2 hidden-xs-only"-->
                <!--                                            :color="itemAvailable(item) === true ? 'green' : 'red'" small>mdi-circle-->
                <!--                                    </v-icon>-->
                {{ item.nameToDisplay }} {{ displayItemVol(item) }}
                <!--                                    <span v-if="item.description"> | {{item.description}}</span>-->
              </div>
              <div v-if="item.extras.length > 0" class="displayExtras">
                {{ item.extras | extrasList(true) }}
              </div>
              <div v-if="item.notes" class="font-italic">{{ item.notes }}</div>
            </div>
            <!--                            <div @click.passive="editNotes(item)" class="displayExtras pointer">-->
            <!--                                <div class="d-inline-block">Anmerkungen</div>-->
            <!--                                <div class="d-inline-block notes" v-if="item.notes.length > 0">:&nbsp;{{item.notes}}-->
            <!--                                </div>-->
            <!--                                <div class="d-inline-block">-->
            <!--                                    &nbsp;<v-icon class="myWhite">mdi-pencil</v-icon>-->
            <!--                                </div>-->
            <!--                            </div>-->
          </td>
          <td class="c counterStuff">
            <v-row>
              <v-col>
                <div class="d-flex align-center maxh" :class="{'justify-end': !item.unikat}">
                  <img class="minusImg pointer invertImg" v-if="!item.unikat"
                       @click.passive="decrementCartItem(item)"
                       src="../assets/icons/item-minus.png">
                  <div>{{ item.count }}</div>
                  <img class="plusImg pointer invertImg" v-if="!item.unikat"
                       @click.passive="incrementCartItem(item)"
                       src="../assets/icons/item-plus.png">
                </div>
              </v-col>
              <!--                                <v-col>-->
              <!--                                    <div class="d-flex justify-end align-center maxh">-->
              <!--                                        <div>{{item.itemTotal | price}}</div>-->
              <!--                                        <v-icon medium @click.native.passive="deleteCartItem(item)"-->
              <!--                                                class="ml-2 hidden-xs-only myWhite pointer" medium>mdi-delete-forever-->
              <!--                                        </v-icon>-->
              <!--                                    </div>-->
              <!--                                </v-col>-->
            </v-row>

            <!--                            <img src="../assets/icons/item-minus.png">-->
          </td>
          <!--                        <td class="counter">{{item.count}}</td>-->
          <!--                        <td class="d counterStuff" @click.passive="incrementCartItem(item)">-->
          <!--                            <img src="../assets/icons/item-plus.png">-->
          <!--                            &lt;!&ndash;                        <v-btn fab dark small color="#617a94">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            <v-icon dark>add</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                        </v-btn>&ndash;&gt;-->
          <!--                        </td>-->
          <!--                        <td class="e text-center">{{item.itemTotal | price}}</td>-->
          <!--                        <td class="f textRight" @click.passive="deleteCartItem(item)">-->
          <!--                            <v-icon medium>mdi-delete-forever</v-icon>-->
          <!--                        </td>-->
        </tr>
      </table>
    </div>


    <div class="indented text-right mt-5" v-if="cartItems.length > 0" style="padding-right: 16px">
      <div class="d-inline-block">
        <table class="mySumTable">
          <!--                        <tr>-->
          <!--                            <td>Gesamtgewicht</td>-->
          <!--                            <td>{{gesamtgewicht}} g</td>-->
          <!--                        </tr>-->
          <!--                        <tr>-->
          <!--                            <td>Zwischensumme</td>-->
          <!--                            <td>{{$store.getters.cartSum | price}}</td>-->
          <!--                        </tr>-->
          <tr v-if="$store.state.rabattSum > 0 && !$store.getters.hidePrices">
            <td>Rabatt</td>
            <td>-{{ $store.state.rabattSum | price }}</td>
          </tr>
          <!--                                v-if="selectedUsecase === 'delivery' || selectedUsecase === 'taxi'"-->
          <!--                        <tr>-->
          <!--                            <td>Lieferkosten</td>-->
          <!--                            <td>{{lieferkosten | price}}</td>-->
          <!--                        </tr>-->
          <tr>
            <td @click.passive="gotoCart" class="pointer">
              <div v-if="totalSavedByDiscounts>0" class="rabattColor">Rabatt:</div>
              <div><h3>Gesamt:</h3></div>
            </td>
            <td @click.passive="gotoCart" class="pointer">
              <div v-if="totalSavedByDiscounts>0" class="rabattColor">- {{ totalSavedByDiscounts | price }}</div>
              <div><h3 :class="{rabattColor: totalSavedByDiscounts>0}">{{ total | priceTotal }}</h3></div>
            </td>
          </tr>
<!--          <tr v-if="takeAwayTotal !== total">-->
<!--            <td><h3>Abholpreis:</h3></td>-->
<!--            <td><h3>{{ takeAwayTotal | price }}</h3></td>-->
<!--          </tr>-->
        </table>
      </div>
      <div>Alle Preisangaben inkl. MwSt.</div>
<!--      <div class="mt-4 ml-2 mr-2">-->
<!--        <v-btn class="btn-df" rounded block-->
<!--               @click="gotoCart">-->
<!--          Zur Kasse-->
<!--        </v-btn>-->
<!--      </div>-->
    </div>


    <div class="indented myWarning" v-if="showMinHint && $store.getters.cartSum < minOrderAmount">
      <div>Es fehlen noch <strong>{{
          minOrderAmount - $store.getters.cartSum |
            price
        }}</strong>
        für den<br><strong>Mindestbestellwert von {{ minOrderAmount |price }}</strong> für {{ describeUsecase }}
      </div>
      <!--                <div>-->
      <!--                    <router-link :to="{ name: 'Filialen' }">(Filiale ändern)</router-link>-->
      <!--                </div>-->
      <div></div>
      <!--                <div v-if="$store.getters.cartSum > 0" class="text-center"-->
      <!--                     style="position: absolute; bottom: -28px; left: 0; width: 100%"><strong>&#45;&#45; ODER &#45;&#45;</strong></div>-->
    </div>
    <div class="indented myWarning" v-if="$store.getters.orderingEnabled === false">
      <h3 class="text-center">Aktuell sind keine Online Bestellungen möglich!</h3>
      Versuche es in ein paar Minuten erneut.
    </div>


    <notes-dialog :dialog="notesDialog" :item="selectedItem" @close="notesDialog = false"></notes-dialog>

    <tischnummer-dialog :dialog="showTischnummer"
                        @tnumberselected="tnumberselected"
                        @close="showTischnummer = false"></tischnummer-dialog>

    <!--        <qsignal class="hide-md"></qsignal>-->

  </div>
</template>

<script>
import * as appManager from '@/vendor/appManager'
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as util from '../vendor/util'
// import * as plausi from '../vendor/plausi'
// import * as firebaseUtil from '../firebase/firebaseUtil'
import * as qconst from '../vendor/qconstants'
import * as bootstrap from '../vendor/bootstrap'
import NotesDialog from "../dialogs/NotesDialog";
import TischnummerDialog from "../dialogs/TischnummerDialog";
import {getDisplayPaymentMethods} from "../vendor/qconstants";
import {roundToTwo} from "../vendor/util";
// import CatSlider from "../components/CatSlider";
// import Qsignal from "../components/qsignal";

// import myline from '../components/myline'

export default {
  components: {
    TischnummerDialog,
    // CatSlider,
    NotesDialog
    // text-center
    // myline
  },
  data() {
    return {
      clientId: '',
      fastUnload: false,
      order: {},
      asGuest: true,
      usecase: qconst.usecase$tableOrdering,
      psp: 'waiter',


      // cartItems: JSON,
      // cartSum: 0,
      selectedItem: {nameToDisplay: '', notes: ''},
      notesDialog: false,

      selectedInhouseWithPay: false,

      selectedPlz: '',
      // relevantDeliveryAddress: {
      //     street: '',
      //     plz: '',
      //     city: '',
      //     etage: '',//optional
      // },

      selectedUsecase: qconst.usecase$takeAway, //initial value
      isBeforeTimeout: true,

      gesamtgewicht: 0,
      lieferkosten: 0,
      // timeUpdater: null,

      showTischnummer: false,

      //testSource: 'https://yt3.ggpht.com/a-/AAuE7mBDq4xMH1_n2OtxrMA7M2e2ZwLQP4013_EDWw=s900-mo-c-c0xffffffff-rj-k-no'
    }
  },
  computed: {
    totalSavedByDiscounts() {
      return 0;// roundToTwo(store.getters.appliedDiscounts.reduce((sum, d) => sum + d.absoluteAmount, 0));
    },
    showMinHint() {
      // if (this.selectedUsecase === qconst.usecase$takeAway) {
      //     return store.getters.selectedStore.minOrderAmount > 0;
      // }
      // return false;
      return true;
    },

    describeUsecase() {
      return 'eine Bestellung';
      // if (this.selectedUsecase === qconst.usecase$takeAway) {
      //     return 'eine Bestellung in der Filiale '
      //         + store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
      // }
      // if (this.selectedUsecase === qconst.usecase$delivery) {
      //     return 'eine Lieferung';
      // }
    },

    minOrderAmount() {
      if (store.getters.inhouse) {
        return 0;//0.5;
      }
      if (this.selectedUsecase === qconst.usecase$takeAway) {
        return store.getters.appconfig.takeAway.minOrderAmount;
      } else if (this.selectedUsecase === qconst.usecase$delivery) {
        return 0;
        // return store.getters.appconfig.takeAway.minOrderAmount;
        // return store.getters.relevantArea.minOrderAmount;
      } else {
        return 0;
      }
    },


    cartItems() {
      return store.getters.cartItems;
    },

    cartSum() {
      return store.getters.cartSum;
    },

    total() {
      return store.getters.payerSum + this.lieferkosten - this.totalSavedByDiscounts;
    },

    takeAwayTotal() {
      // if(store.state.takeAwayPayerSum < store.getters.payerSum){
      return store.state.takeAwayPayerSum;
      // }else{
      //     return store.getters.payerSum + store.getters.relevantArea.fee;
      // }
    }
    // minDiff() {
    //     return store.getters.appconfig.takeAway.minOrderAmount - store.getters.cartSum;
    // }
  },
  created() {
    ebus.$on(qconst.notify$appLoaded, () => {
      this.init();
    });
  },

  mounted() {
    store.state.hideScroll = true;
    this.init();
    // setTimeout(() => {
    //     util.jumpToTop();
    // }, 120);

    setTimeout(() => {
      if (store.state.cartId.length > 0) {
        store.commit('cartId', '');
        this.$router.push({name: 'checkouttakeAway'});
      }
    }, 400);
    // firebaseUtil.gevent('view_cart', {
    //     currency: 'EUR',
    //     value: this.total,
    //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems))
    // });
  },

  destroyed() {
    util.clearEvents([
      qconst.notify$appLoaded,
    ]);

    store.state.hideScroll = false;
    // util.clearTheInterval(this.timeUpdater);
  },

  methods: {
    init() {
      this.updateLieferkosten();
      // // store.commit('currentRoute', 'Korb');
      // ebus.$emit('updateRelevantArea');
      // // let restName = '' + store.state.restaurantData.restaurantName;
      // // store.commit('headerTitle', restName);
      //
      // // this.cartItems = store.getters.cartItems;
      // // this.cartSum = store.getters.cartSum;

      // this.updateTime();
      // this.timeUpdater = setInterval(() => {
      //     this.updateTime();
      // }, 10 * 1000);
    },

    showHintForGroup() {
      //show question
      setTimeout(() => {
        ebus.$emit('showQuestion', {
          quest: 'Hinweis für Gruppen',
          text: '<p>In einer Gruppe kann jeder für sich mit seinem eigenen Smartphone bestellen und ' +
            'danach sollte eine Person eurer Wahl den Button <b>WIR SIND FERTIG</b> drücken.</p>' +
            '<p>Der Button wird dir/euch nach der Bestellung angezeigt.</p>',
          yesLabel: 'Ok, vestanden',
          // noLabel: '',
          // yesAction: null,
          cb: 'cb-hintForGroup'
        });
      }, 800);
    },

    // saveOrder(useExistingOrder) {
    //     // if (store.getters.restId === 'x0') {
    //     //     return;
    //     // }
    //     console.log('??? save order');
    //     try {
    //         let checkpoints = 0;
    //         store.commit('showLoading', true);
    //         // this.safeUnload();
    //         let order;
    //         if (useExistingOrder) {
    //             order = util.cloneMe(this.order);
    //         } else {
    //             ++checkpoints;
    //             order = this.generateOrder();
    //             ++checkpoints;
    //         }
    //
    //         let msg = {
    //             action: qconst.action$SaveNewOrder,
    //             order: order,
    //             captchaText: 'roomtabletsmelody',//'' + this.captchaInput
    //         };
    //
    //         // msg.paymentIntentId = this.paymentIntentId;
    //         // msg.paymentMethodId = this.paymentMethodId;
    //         if (this.psp === 'credit' || this.psp === 'wallet') {
    //             // useExistingOrder is always be true if psp=stripe because intent status here is requires_action
    //             msg.stripeCustomerId = store.state.stripeCustomerId;
    //             msg.saveStripeAuth = useExistingOrder;//tell the server to save the stripePreAuth or not
    //             if (useExistingOrder) {
    //                 msg.stripePreAuth = util.cloneMe(this.stripePreAuth);
    //             }
    //         } else if (this.psp === 'paypal') {
    //             //paypalPreAuth contains
    //             // paypalOrderId,orderNumber,uniqueOrderId,createdAt,amount,paypalAuthId,sellerAccountId,fuid
    //             msg.paypalPreAuth = util.cloneMe(this.paypalPreAuth);
    //
    //             //at this point neither the order nor the paypalPreAuth are saved
    //         }
    //         ++checkpoints;
    //
    //         // setTimeout(() => {
    //         //     store.commit('showLoading', false);
    //         // }, 3000);
    //         xhr.xhrSend(true, msg, (reply) => {
    //             //either ok with orderId or notOk
    //             store.commit('showLoading', false);
    //             ++checkpoints;
    //             if (reply.ok) {
    //                 ebus.$emit('loadLastOrders');//preload last orders
    //                 // ebus.$emit('info', 'Deine Bestellung wurde erfolgreich übermittelt!');
    //                 // this.notifyInfo('Deine Bestellung war erfolgreich!');
    //                 //reply.orderId
    //                 console.log('??? orderId = ' + reply.id);
    //
    //                 //save as lastOrder
    //                 order.id = reply.id;
    //                 order.orderNumber = reply.orderNumber;
    //                 order.uniqueOrderId = reply.uniqueOrderId;
    //                 order.createdAt = reply.createdAt;
    //                 delete order.action;
    //                 delete order.appId;
    //                 delete order.channel;
    //                 ++checkpoints;
    //                 this.$ls.set('lastOrder', order);
    //                 // ebus.$emit('orderSuccess');
    //
    //                 // this.logPurchase();
    //                 ++checkpoints;
    //                 store.commit('deleteAllCartItems');
    //                 ++checkpoints;
    //                 this.$router.replace({name: 'Bestellung', params: {uniqueOrderId: order.uniqueOrderId}});
    //                 if (!qconst.withPosApi) {
    //                     setTimeout(() => {
    //                         ebus.$emit('showAlleFertigDialog');
    //                     }, 5000)
    //                 }
    //                 // this.$router.replace({name: 'Bestaetigung'});
    //             } else {
    //                 checkpoints += 100;
    //                 if (reply.captchaError) {
    //                     checkpoints += 200;
    //                     this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
    //                 } else {
    //                     checkpoints += 300;
    //                     this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
    //                 }
    //                 this.reloadCaptcha();
    //                 checkpoints += 10000;
    //
    //                 store.commit('showLoading', false);
    //
    //                 ebus.$emit('throwError', getErrorDetails('Error in save new order, checkpoints: ' + checkpoints);
    //             }
    //         }, (err) => {
    //             checkpoints += 20000;
    //             ebus.$emit('throwError', getErrorDetails('Transport error in save new order; checkpoints: ' + checkpoints);
    //             store.commit('showLoading', false);
    //             this.notifyError('Unerwarteter Fehler', 'Eventuell ist dein Internet unterbrochen');
    //             setTimeout(() => {
    //                 ebus.$emit('reload', true)
    //             }, 2500);
    //         });
    //     } catch (e) {
    //         checkpoints += 30000;
    //         ebus.$emit('throwError', getErrorDetails('Exception in save new order: ' + e.message + '; checkpoints: ' + checkpoints);
    //         console.log('!!!!! error: ' + e.message);
    //     }
    //
    // },

    // generateOrder() {
    //     try {
    //         if (!this.clientId) {
    //             this.$ls.set('clientId', util.generateClientId());
    //         }
    // 		let order = {
    //             clientId: '' + this.$ls.get('clientId'),
    //       lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
    //             asGuest: this.asGuest,
    //             type: 'selfOrder',
    //             //TODO activate for firebase
    //             fuid: null,
    //             // fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
    //             domain: window.location.hostname,
    //             channel: 'on-the-go',
    //             usecase: this.usecase,
    //             btaste: bootstrap.getBtaste(),
    //             // restaurantId: store.getters.restId,
    //             createdAt: Date.now(),// this.createdAt,
    //             table: parseInt(store.getters.table),
    //             //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
    //             // delayInMinutes: store.getters.delayInMinutes,
    //             // expectedDelayInMinutes: store.getters.delayInMinutes,
    //             orderData: util.cloneMe(store.getters.cartItems),
    // appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
    //             // company: '' + this.company,
    //             userInfo: util.cloneMe(store.state.user),
    //             pickupDate: util.cloneMe(this.pickupDate),
    //             targetTime: this.pickupDate.utc,
    //             onlinePay: false,
    //             // onlinePay: this.psp !== 'bar' && this.psp !== 'beiAbholung',
    //             paymentInfo: {
    //                 psp: '' + this.psp,
    //                 amount: this.total
    //             },
    //             note: '',
    //             // invoiceAddress: {
    //             //     company: '' + this.invoiceAddress.company.trim(),
    //             //     street: '' + this.invoiceAddress.street.trim(),
    //             //     plz: util.getSaneStr(this.invoiceAddress.plz),
    //             //     city: '' + this.invoiceAddress.city.trim(),
    //             //     // etage: '' + this.deliveryAddress.etage.trim(),
    //             // }
    //             // deliveryAddress: {
    //             //     company: '' + this.deliveryAddress.company.trim(),
    //             //     street: '' + this.deliveryAddress.street.trim(),
    //             //     plz: '' + this.deliveryAddress.plz.trim(),
    //             //     city: '' + this.deliveryAddress.city.trim(),
    //             //     etage: '' + this.deliveryAddress.etage.trim(),
    //             // }
    //         };
    //
    //         if (this.note) {
    //             order.note = '' + this.note;
    //         }
    //
    //         if (this.asGuest) {
    //             order.userInfo = {
    //                 btaste: bootstrap.getBtaste(),
    //                 name: '' + this.name,
    //                 email: util.sanitizeEmail(this.email),
    //                 phone: '' + this.phone,
    //             };
    //         }
    //
    //         // if (!this.sameAsInvoiceAddress) {
    //         //     order.deliveryAddress = {
    //         //         company: '' + this.deliveryAddress.company.trim(),
    //         //         street: '' + this.deliveryAddress.street.trim(),
    //         //         plz: util.getSaneStr(this.deliveryAddress.plz),
    //         //         city: '' + this.deliveryAddress.city.trim(),
    //         //         etage: '' + this.deliveryAddress.etage.trim(),
    //         //     };
    //         // }//else we only submit the invoiceAddress
    //
    //         util.sanitizeProps(order.userInfo);
    //         // util.sanitizeProps(order.invoiceAddress);
    //         // util.sanitizeProps(order.deliveryAddress);
    //
    //         //add app string
    //         // if (breakpoints.getCurrentDevice() === 'xs') {
    //         //     order.app = 'LIEFERMAXX Mobile App'
    //         // } else {
    //         //     order.app = 'LIEFERMAXX App'
    //         // }
    //
    //         //add operating system
    //         order.userAgentData = window.navigator.userAgentData;
    //
    //         // if (this.onlinePay) {
    //         //     // order.orderNumber = this.orderNumber;
    //         //     // order.uniqueOrderId = this.uniqueOrderId;
    //         //
    //         //     order.paymentInfo.psp = 'stripe';
    //         //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
    //         //     // order.paymentInfo.paymentMethodId = this.selectedPaymentMethodId;
    //         // }
    //         // if (this.usecase === 'delivery') {
    //         //     if (this.deliveryAddress.etage.length > 0) {
    //         //         order.deliveryAddress.etage = this.deliveryAddress.etage;
    //         //     }
    //         order.paymentInfo.itemsTotal = store.getters.cartSum;
    //         order.paymentInfo.deliveryFee = 0;// + store.state.deliveryFee;
    //         //     // let fee = null;
    //         //     // for (let area of store.getters.appconfig.deliveryAreas) {
    //         //     //     if (area.plz === order.deliveryAddress.plz) {
    //         //     //         fee = area.fee;
    //         //     //         break;
    //         //     //     }
    //         //     // }
    //         //     // if (fee === null) {
    //         //     //     //error
    //         //     //     this.notifyError('Fehler bei den Lieferkosten');
    //         //     //     return null;
    //         //     // }
    //         //     // order.paymentInfo.amount = this.total;
    //         // } else {
    //         // order.pickupStore = util.cloneMe(store.getters.selectedStore);
    //         // delete order.pickupStore.openingHours;
    //         // order.storeId = '' + store.getters.selectedStore.filialnummer;
    //         // }
    //         return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
    //     } catch (e) {
    //         ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message);
    //         return null;
    //     }
    // },

    notifyError(text, err) {
      ebus.$emit('info', 'Fehler: ' + text + ' ' + (err || ''));
    },

    tnumberselected(num) {
      ebus.$emit('userEnteredTable', num);
      this.finishComplexer();
    },

    itemAvailable(item) {
      return true;
      // return plausi.itemAvailableTomorrow(item);
    },

    updateGesamtgewicht() {
      let g = 0;
      for (let ci of store.getters.cartItems) {
        if (ci.gramm) {
          g += (ci.gramm * ci.count);
        } else {
          g += (300 * ci.count);
        }
      }
      this.gesamtgewicht = g;
    },

    updateLieferkosten() {
      // this.updateGesamtgewicht();
      //
      // let pack = 0.5;
      // let vsand = 5.49;
      // let anyAll = false;
      //
      // //Produktaußnahmen
      // //1. Schraubflasche 100ml	Maxibrief				3,20 €
      // if (!anyAll) {
      //     let allSchraub100 = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Schraub') !== -1 && itm.descriptionDE.indexOf('100') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Schraub') !== -1 && itm.nameToDisplay.indexOf('100') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allSchraub100 = false;
      //     }
      //     if (allSchraub100) {
      //         anyAll = true;
      //         pack = 0;
      //         vsand = 2.70;
      //     }
      // }
      //
      // //2. Herzflasche 50ml 	Maxibrief				3,20 €
      // if (!anyAll) {
      //     let allHerz50 = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Herzfl') !== -1 && itm.descriptionDE.indexOf('50') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Herzfl') !== -1 && itm.nameToDisplay.indexOf('50') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allHerz50 = false;
      //     }
      //     if (allHerz50) {
      //         anyAll = true;
      //         pack = 0.5;
      //         vsand = 2.70;
      //     }
      // }
      //
      //
      // //3. Mosaik-CD       		Großbrief bis 500g 		7,95 €
      // if (!anyAll) {
      //     let allMosaikCD = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Mosaik') !== -1){ // && itm.descriptionDE.indexOf('CD') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Mosaik') !== -1){// && itm.nameToDisplay.indexOf('CD') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allMosaikCD = false;
      //     }
      //     if (allMosaikCD) {
      //         anyAll = true;
      //         pack = 0.5;
      //         vsand = 1.55;
      //     }
      //     console.log('allMosaikCD = ' + allMosaikCD);
      // }
      //
      //
      //
      // //calculare gesamtgewicht
      // let grammTotal = this.gesamtgewicht;
      // if (grammTotal > 5000) {
      //     vsand = 9.49;
      // } else if (grammTotal > 2000 && vsand < 6.49) {
      //     vsand = 6.49;
      // } else if (grammTotal > 1000 && vsand < 5.49) {
      //     vsand = 5.49;
      // }
      //
      // //calculare liefer / versandkosten
      // console.log('Verpackung = ' + pack);
      // console.log('Versand = ' + vsand);
      // this.lieferkosten = pack + vsand;
      // store.commit('deliveryFee', 0 + this.lieferkosten);
      // // return store.state.deliveryFee;
      // // return store.getters.selectedStore.fee;
    },

    gotoCat(cat) {
      store.state.shouldJump = true;
      this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
    },

    gotoAholung() {
      this.$router.push({name: 'Abholung'});
    },

    // initSlider() {
    //     let foodCats = util.cloneMe(store.getters.foodMenu);
    //     // console.log('so do we have cats??? ' + foodCats.length);
    //     for (let fcat of foodCats) {
    //         if (!fcat.items) {
    //             continue;
    //         }
    //         // for (let item of fcat.items) {
    //         //     let offerAndItem = store.getters.getOfferByItemId(item.id);
    //         //     // item.offered = !!offerAndItem;
    //         //     // if (!!offerAndItem) {
    //         //     //     item.offerId = offerAndItem.offer.id;
    //         //     // }
    //         //     this.applyOfferAndPrices(item, offerAndItem);
    //         // }
    //     }
    //     this.foodCategories = foodCats;
    //     // this.loaded = true;
    // },

    clickStartOrder() {
      util.delayScroll('usecases');
    },

    // updateTime() {
    //     //Abholung nur bis 16:30 Uhr möglich
    //     let now = util.getCurrentRemoteTime();
    //     let h = now.getHours();
    //     let m = now.getMinutes();
    //     // console.log('Now time = ' + h + ' : ' + m);
    //
    //     let takeawayPossible = false;
    //     if (h < 16) {
    //         takeawayPossible = true;
    //     } else if (h === 16) {
    //         takeawayPossible = (m <= 30);
    //     }
    //     this.isBeforeTimeout = takeawayPossible;
    // },

    gotoWebsite(url) {
      let win = window.open(url, '_blank');
      win.focus();
    },

    showCouponInfo(c) {
      ebus.$emit('openCouponInfo', c);
    },

    goforTakeaway() {

      this.doOrder();
    },

    editNotes(item) {
      this.selectedItem = item;
      this.notesDialog = true;
    },

    gotoItem(item) {
      if (item.type === qconst.type$foodOrder) {
        // this.$router.push({name: 'foodItem', params: {foodId: item.id}});
        this.$router.push({
          name: 'Speise',
          params: {itemId: item.id},
          query: {cartItemId: item.cartItemId}
        });
      } else if (item.type === qconst.type$drinkOrder) {
        this.$router.push({
          name: 'Getraenk',
          params: {itemId: item.id},
          query: {cartItemId: item.cartItemId}
        });
      }
    },

    // gotoFoods() {
    //     // store.commit('currentTab', 'tab-1');
    //     this.$router.push({name: 'order'});
    //     // ebus.$emit(qconst.notify$tabSwitched);
    // },

    gotoSpeisen() {
      this.$router.push({name: 'Speisen', params: {catname: 'all'}});
    },

    displayItemVol(item) {
      if (item.vol.length === 0 || item.vol.toLowerCase().indexOf('standard') !== -1) {
        return '';
      } else {
        return item.vol;
      }
    },

    lazyGoBack() {
      if (this.cartItems.length === 0) {
        this.$router.go(-1);
      }
    },

    deleteCartItem(cartItem) {
      console.log('deleteCartItem 5');
      store.commit('deleteCartItem', cartItem);
      // firebaseUtil.gevent('remove_from_cart', {
      //     currency: 'EUR',
      //     value: cartItem.itemTotal,
      //     items: [util.cloneMe(firebaseUtil.getGitemFromCartItem(cartItem))]
      // });
      this.lazyGoBack();
    },

    decrementCartItem(cartItem) {
      console.log('decrementCartItem 1');
      store.commit('decrementCartItem', cartItem);
      // firebaseUtil.gevent('remove_from_cart', {
      //     currency: 'EUR',
      //     value: cartItem.itemTotal,
      //     items: [util.cloneMe(firebaseUtil.getGitemFromCartItem(cartItem))]
      // });
      this.updateLieferkosten();
      this.lazyGoBack();
    },

    incrementCartItem(cartItem) {
      store.commit('incrementCartItem', cartItem);
      this.updateLieferkosten();
    },

    // chooseUsecase(uc) {
    //   try {
    //     // store.commit('selectedUsecase', uc);
    //     this.selectedUsecase = uc;
    //     if (uc === qconst.usecase$takeAway) {
    //
    //       //Gebe eine Einführung
    //       // let introAbholung = this.$ls.get('introAbholung', {v: false});
    //       // if (!introAbholung.v) {
    //       //     ebus.$emit('showQuestion', {
    //       //         quest: 'Möchten Sie eine kurze Einführung zu unserem Bestellprozess haben?',
    //       //         yesAction: null,
    //       //         qtext: 'Nach der Einführung können Sie Ihren Bestellvorgang fortsetzen.',
    //       //         yesLabel: 'Zur Einführung',
    //       //         cb: 'cb-introAbholung cb-chooseUsecase'
    //       //     });
    //       //     return;
    //       // }
    //
    //       //Prüfe Verfügbarkeit aller Waren
    //       // let itemsNotAvailable = [];
    //       // for (let itm of store.getters.cartItems) {
    //       //     if (itm.couponCode) {
    //       //         continue;
    //       //     }
    //       //     if (!plausi.itemAvailableTomorrow(itm)) {
    //       //         itemsNotAvailable.push(itm);
    //       //     }
    //       // }
    //       // if (itemsNotAvailable.length > 0) {
    //       //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
    //       //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
    //       //     ebus.$emit('showInfo', {
    //       //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
    //       //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
    //       //     });
    //       //     util.jumpToTop(true);
    //       //     return;
    //       // }
    //
    //
    //       // //First choose a filiale
    //       // if (!store.getters.selectedStore.strasse) {//|| store.getters.selectedTime.value.length < 1
    //       //     this.$router.push({name: 'Filialen', query: {select: 'true'}});
    //       //     return;
    //       // }
    //
    //       //FIXME 16:30 Uhr => only during dev or demo
    //       // if (!this.isBeforeTimeout) {
    //       //     ebus.$emit('showInfo', {
    //       //         title: 'Heute kann nicht mehr zum Abholen bestellt werden!',
    //       //         text: 'Bitte versuche es Morgen wieder bis spätestens 16:30 Uhr.'
    //       //     });
    //       //     return;
    //       // } else {
    //       this.doOrder();
    //       // }
    //     } else if (uc === qconst.usecase$delivery) {
    //       this.doOrder();
    //     } else {
    //       ebus.$emit('showInfo', {
    //         title: 'Diese Funktion befindet sich in Vorbereitung und wird demnächst bereitgestellt',
    //         text: 'Bitte versuche es in ein paar Tagen nochmal!'
    //       });
    //     }
    //   } catch (e) {
    //     console.log('Error Datenprüfung: ' + e.message);
    //     ebus.$emit('info', 'Fehler bei der Datenprüfung');
    //   }
    // },

    gotoCart() {
      this.$router.push({name: 'Korb'});
    },

    doOrder() {

      //Als Gast bestellen
      this.$ls.set('asGuest', true);

      if (store.getters.inhouse) {
        //custom
        this.finishComplexer();
        // if (qconst.forceTableScan) {
        //     if (this.$store.getters.table > 0) {
        //         store.commit('table',this.$store.getters.table);
        //         this.clickOrder();
        //     } else {
        //         ebus.$emit('suggestQrCodeScan');
        //     }
        // } else {
        //     this.showTischnummer = true;
        // }
      } else {
        this.finishComplexer();
      }


      // if(store.state.selectedUsecase === ''){
      //     ebus.$emit('showInfo', {
      //         title: 'Bitte wähle deinen Anwendungsfall aus';
      //     });
      //     ebus.$emit('gotoStart');
      // };

      // //now the selectedUsecase is set and checked
      // try {
      //     console.log('doOrder hasAccount = ' + bootstrap.hasAccount());
      //     if (!bootstrap.hasAccount()) {
      //         this.$ls.set('gotoSummaryAfterAccount', '1');
      //     }
      //
      //     // if (isInsideAndroid) {
      //     //     if (store.getters.cartItems.length === 0) {
      //     //         return;
      //     //     }
      //     //
      //     //     let cartId = this.$ls.get('cartId');
      //     //     if (!cartId) {
      //     //         cartId = util.generateClientId();
      //     //         this.$ls.set('cartId', cartId);
      //     //     }
      //     //
      //     //     let msg = {
      //     //         action: qconst.action$MC_SaveCartItems,
      //     //         cartId: cartId,
      //     //         items: store.getters.cartItems
      //     //     };
      //     //     xhr.xhrSend(true, msg, (data) => {
      //     //         if (data && data.ok) {
      //     //             let url = 'https://theurer.app/?cartId=' + cartId;
      //     //             let win = window.open(url);
      //     //             win.focus();
      //     //         } else {
      //     //             ebus.$emit('info', 'Error: Fehler bei der Übermittlung. Bitte versuche es noch einmal!');
      //     //         }
      //     //     }, (err) => {
      //     //         // logError('Load orders');
      //     //         console.log('Error in action$MC_SaveCartItems', JSON.stringify(err));
      //     //     });
      //     // } else
      //     if (!firebaseUtil.getUser()) {
      //         this.askForGuest();
      //
      //         // if (bootstrap.hasAccount()) {
      //         //     this.$ls.remove('asGuest');
      //         //     store.commit('currentNext', 'Korb');
      //         //     console.log('summary goto signin');
      //         //     this.$router.push({name: 'Anmelden'});
      //         // } else {
      //         //     this.askForGuest();
      //         //     // store.commit('currentNext', 'Korb');
      //         //     // console.log('summary goto register');
      //         //     // this.$router.push({name: 'Registrierung'});
      //         // }
      //     } else {
      //         if (bootstrap.hasAccount()) {
      //             this.$ls.remove('asGuest');
      //             console.log('???? goto checkout');
      //             console.log('summary goto checkout');
      //             this.clickOrder();
      //         } else {
      //             //double check
      //             if (firebaseUtil.isAccount()) {
      //                 this.$ls.set('hasAccount', 'true');
      //                 this.$ls.remove('asGuest');
      //                 this.clickOrder();
      //             } else {
      //                 this.askForGuest();
      //                 // console.log('???? goto register');
      //                 // store.commit('currentNext', 'Korb');
      //                 // console.log('summary goto register');
      //                 // this.$router.push({name: 'Registrierung'});
      //             }
      //         }
      //         // sendOrder();
      //     }
      // } catch (e) {
      //     alert('Fehler: ' + e.message);
      // }
    },
    finishComplexer() {
      console.log('???? goto checkout');
      if (store.getters.inhouse) {
        if (store.getters.enableInhousePay) {
          //show question
          ebus.$emit('showQuestion', {
            quest: 'Möchtest du online bezahlen?',
            text: getDisplayPaymentMethods(true),
            yesLabel: 'Ja, online bezahlen',
            noLabel: 'Zahlung beim Kellner',
            // yesAction: null,
            cb: 'cb-inhouseWithPay'
          });

        } else {
          this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
        }
      } else {
        if (this.selectedUsecase.length > 0) {
          this.$router.push({name: 'checkout' + this.selectedUsecase});
        }
      }
    },
    // askForGuest() {
    //     ebus.$emit('showQuestion', {
    //         quest: 'Möchtest du dich als Kunde registrieren oder nur als Gast bestellen?',
    //         yesAction: null,
    //         qtext: 'Als registrierter Kunde kannst du dich bequem per Facebook, Email oder per Mobilnummer anmelden.',
    //         yesLabel: 'Als Gast',
    //         noLabel: 'Als Kunde',
    //         cb: 'cb-asGuest'
    //     });
    //     store.commit('showLoading', true);
    // }
  }
}
</script>


<style lang="scss" scoped>
@import '../styles/base';
/*@import '../styles/sharedStyles';*/

/*.highlight {*/
/*color: white;*/
/*}*/

.thisBtn ::v-deep .v-btn {
  background-color: $accent !important;
  color: black !important;
}

.this {
  margin-left: 10px;
  position: sticky;
  top: 79px;
  padding: 1vw;
  border: 2px solid $accent;
  border-radius: $box-border-radius;
  background-color: white;
  /*background-color: white;*/
  /*columns: black;*/
}

.bgw {
  /*<!--border-right: $box-border-radius;-->*/
}

.order-container {
  max-width: 300px;
  width: 70%;
}

.notes {
  font-style: italic;
}

.takeawayOption {
  margin: 0 20px 0 20px;
}

.mySumTable {
  td {
    padding-left: 12px;
  }
}

/*.minusImg{*/
/*    width: 25px;*/
/*}*/

/*.plusImg{*/
/*    width: 32px;*/
/*}*/

.counterStuff {
  /*width: 40px;*/
  text-align: center;

  padding: 0;

  img {
    width: 32px;
    height: auto;
    margin: 0 15px;
    /*margin-top: 5px;*/
  }

  /*::v-deep .ocl{*/
  /*    padding: 4px;*/
  /*}*/

  /*>>> .v-btn{*/
  /*    width: 32px;*/
  /*    height: 32px;*/
  /*    margin: 0;*/
  /*}*/
}

td.counter {
  width: 27px;
  font-size: 1.2em;
  text-align: center;
}

/* Debug tables */
/*table, th, td {*/
/*    border: 1px solid blue;*/
/*}*/

.itemRow {
  //background-color: $color-darkblue;
  //color: white;
  //@include material-shadow(1);
  border-bottom: 1px solid #666;

}

.pmRow {
  padding: 8px;
  /*padding: 4px 0;*/
}

.items {
  /*border-collapse: collapse;*/

  td {
    //background-color: $color-darkblue;
    //color: white;
  }

  .a {
    width: 38px;
  }

  .b {
    width: 85%;
    /*padding-left: 1%;*/
    vertical-align: center;
  }

  .c {

  }

  .d {

  }

  .e {
    width: 60px;
  }

  .f {
    width: 30px;
  }
}

.displayExtras {
  color: rgba($font-color, 0.8);
}

.myWarning {
  color: red;
  margin: 15px 0;
  /*border: 2px solid red;*/
  padding: 8px 0;
  position: relative;
}

// .backBtn.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
//     background-color: $primary-color-2;
// }

.usecase {
  border-radius: $box-border-radius;
  cursor: pointer;
  padding: 2.5vw 2.5vw;
  /*    !*margin: 20px;*!*/
  /*    //border-radius: $box-border-radius;*/
  /*    border-radius: 25px;*/
  /*    //@include material-shadow(1);*/
  height: 100%;
  position: relative;
  padding-bottom: 150px;
  /*    background-color: white;*/

  /*    &.highlight {*/
  /*        color: white;*/

  /*        .nice-title {*/
  /*            color: white;*/
  /*        }*/
  /*    }*/
  background-color: $bg2;

  &:hover {
    //@include material-shadow(2);
    background-color: $bg2;
  }

  /*    &.fade {*/
  /*        filter: grayscale(100%);*/
  /*        opacity: 0.7;*/
  /*    }*/

  .choose {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    text-align: center;
  }
}

.theader {
  /*border-collapse: collapse;*/
  td {
    padding-bottom: 10px;
    font-size: 1.2em;
    //font-weight: 700;
    border-bottom: 1px solid #666;
  }
}

/*.device-md {*/
/*    .absBack {*/
/*        position: sticky*/
/*    }*/
/*}*/

.vdevice-not-xs {
  .counterStuff .row {
    flex-wrap: nowrap;
  }
}

.vdevice-xs {
  .plusImg {
    margin-right: 0;
  }

  .anzahl {
    text-align: right;
  }
}

</style>
